import { defineMessages } from 'react-intl';

export const messages = {
  success: defineMessages({
    instructorAdded: {
      id: 'instructors.success.instructor-added',
      defaultMessage: 'Instructor was successfully added',
    },
    instructorEdited: {
      id: 'instructors.success.instructor-edited',
      defaultMessage: 'Instructor was successfully edited',
    },
    instructorDeleted: {
      id: 'instructors.success.instructor-deleted',
      defaultMessage: 'Instructor was successfully deleted',
    },
  }),
  error: defineMessages({
    problemWithRequest: {
      id: 'instructors.error.problem-with-request',
      defaultMessage: 'There was a problem with your request.',
    },
    notSupported: {
      id: 'instructors.error.not-supported',
      defaultMessage: 'This feature is currently not supported for this venue.',
    },
    photoTooLarge: {
      id: 'instructors.error.photo-too-large',
      defaultMessage: 'Uploaded file is too large. Please select a different file.',
    },
  }),
  deleteModal: defineMessages({
    title: {
      id: 'instructors.delete-modal.title',
      defaultMessage: 'Delete instructor',
    },
    description: {
      id: 'instructors.delete-modal.description',
      defaultMessage:
        'Are you sure you want to delete this instructor? Existing classes will not be canceled. Please cancel classes directly in the "Schedule Settings" tab. Deleting this instructor will not remove their ratings and reviews on your venue.',
    },
    cancel: {
      id: 'instructors.delete-modal.cancel',
      defaultMessage: 'Cancel',
    },
    confirm: {
      id: 'instructors.delete-modal.confirm',
      defaultMessage: 'Confirm',
    },
  }),
  buttons: defineMessages({
    addInstructor: {
      id: 'instructors.add-instructor-button.add',
      defaultMessage: 'Add Instructor',
    },
  }),
  details: defineMessages({
    selectInstructor: {
      id: 'instructor-details.select-instructor',
      defaultMessage: 'Select an instructor to view their details',
    },
  }),
  form: defineMessages({
    cancel: {
      id: 'instructor-form.cancel',
      defaultMessage: 'Cancel',
    },
    save: {
      id: 'instructor-form.save',
      defaultMessage: 'Save',
    },
    addInstructorTitle: {
      id: 'instructor-form.add-instructor-title',
      defaultMessage: 'Add New Instructor',
    },
    editInstructorTitle: {
      id: 'instructor-form.edit-instructor-title',
      defaultMessage: 'Edit Instructor',
    },
    firstNameLabel: {
      id: 'instructor-form.first-name-label',
      defaultMessage: 'First Name',
    },
    lastNameLabel: {
      id: 'instructor-form.last-name-label',
      defaultMessage: 'Last Name',
    },
    emailAddressLabel: {
      id: 'instructor-form.email-address-label',
      defaultMessage: 'Email Address',
    },
    phoneNumberLabel: {
      id: 'instructor-form.phone-number-label',
      defaultMessage: 'Phone Number',
    },
    venueLocationsLabel: {
      id: 'instructor-form.venue-locations-label',
      defaultMessage: 'Locations',
    },
    bioLabel: {
      id: 'instructor-form.bio-label',
      defaultMessage: 'Trainer Bio',
    },
    certificationsLabel: {
      id: 'instructor-form.certifications-label',
      defaultMessage: 'Certifications / Specialities',
    },
    delete: {
      id: 'instructor-form.delete',
      defaultMessage: 'Delete',
    },
  }),
};
